import { get } from 'lodash';

import * as CardApi from '@/api/card';
import actionTypes from './actionType';

const setRoomListLoading = (loading) => {
  return {
    type: actionTypes.SET_ROOM_LIST_LOADING,
    payload: {
      roomListLoading: loading,
    },
  };
};

const initRoomList = (params) => {
  return async (dispatch) => {
    dispatch(setRoomListLoading(true));
    try {
      const res = await CardApi.fetchRoomList(params);
      dispatch(setRoomListLoading(false));
      dispatch({
        type: actionTypes.INIT_ROOM_LIST,
        payload: {
          roomList: get(res, 'data', []),
        },
      });
    } catch (err) {
      dispatch(setRoomListLoading(false));
    }
  };
};

const setRoomCardEnabled = (roomCardEnabled) => {
  return {
    type: actionTypes.SET_ROOM_CARD_ENABLED,
    payload: {
      roomCardEnabled,
    },
  };
};

const setEnabledVerndor = (vendorInfo) => {
  return {
    type: actionTypes.SET_ENABLED_VENDOR,
    payload: {
      enabledVendor: vendorInfo,
    },
  };
};

export { initRoomList, setRoomCardEnabled, setEnabledVerndor };
